// Cross-tab sign-out: sibling tabs reload instead of running on a dead cookie.
// Best-effort — frozen/bfcached tabs miss it; the mint check is the guarantee.
const CHANNEL_NAME = 'atm-auth'

type AuthMessage = { event: 'signed-out' }

const openChannel = (): BroadcastChannel | undefined =>
  typeof BroadcastChannel === 'undefined'
    ? undefined
    : new BroadcastChannel(CHANNEL_NAME)

export const broadcastSignOut = (): void => {
  const channel = openChannel()
  if (!channel) return
  channel.postMessage({ event: 'signed-out' } satisfies AuthMessage)
  channel.close()
}

// Other tabs only: BroadcastChannel never delivers to the posting tab.
export const onSignOutElsewhere = (callback: () => void): (() => void) => {
  const channel = openChannel()
  if (!channel) return () => undefined
  channel.onmessage = (message: MessageEvent<AuthMessage>) => {
    if (message.data?.event === 'signed-out') callback()
  }
  return () => channel.close()
}
